import ShareJobs from "./ShareJobs";
import SocialShare from "./SocialShare";

export default SocialShare;
export { ShareJobs };
